// removed by extract-text-webpack-plugin
module.exports = {"Modal":"ShareDialog__Modal___sCz68","ModalDescription":"ShareDialog__ModalDescription___3d8pc","ModalCheckboxes":"ShareDialog__ModalCheckboxes___tUCMX","SendLink":"ShareDialog__SendLink___KMkIv","ModalNotification":"ShareDialog__ModalNotification___10_LG","SendCollectionInputWrap":"ShareDialog__SendCollectionInputWrap___1_w5B","SendCollectionInput":"ShareDialog__SendCollectionInput___1Mfh1","SendCollectionBtn":"ShareDialog__SendCollectionBtn___LTvyT","SendPdf":"ShareDialog__SendPdf___2mmmL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ShareDialog/ShareDialog.scss
// module id = 1383
// module chunks = 0